/**
 * Modules Constants
 * Defines all available modules in the system
 */
export const MODULES = {
  DASHBOARD: "dashboard",
  INTEGRATIONS: "integrations",
  SOCIAL_ASSISTANCE: "social_assistance",
  EMPLOYEES: "employees",
  EVENTS: "events",
  YOUTH_INDEX: "youth_index",
  YOUTH_LIST: "youth_list",
  YOUTH_BALANCE: "youth_balance",
} as const;

/**
 * Module Type
 * Union type of all possible module values
 */
export type Module =
  | typeof MODULES.DASHBOARD
  | typeof MODULES.INTEGRATIONS
  | typeof MODULES.SOCIAL_ASSISTANCE
  | typeof MODULES.EMPLOYEES
  | typeof MODULES.EVENTS
  | typeof MODULES.YOUTH_INDEX
  | typeof MODULES.YOUTH_LIST
  | typeof MODULES.YOUTH_BALANCE;

/**
 * Array of all module values
 */
export const MODULES_LIST: readonly Module[] = [
  MODULES.DASHBOARD,
  MODULES.INTEGRATIONS,
  MODULES.SOCIAL_ASSISTANCE,
  MODULES.EMPLOYEES,
  MODULES.EVENTS,
  MODULES.YOUTH_INDEX,
  MODULES.YOUTH_LIST,
  MODULES.YOUTH_BALANCE,
] as const;
